export default {
	service: [
		"Servizio",
		"Evento",
		"Prelievo",
		"Deposito",
		"Termini e Condizioni",
		"Certificato",
		"FAQ",
		"Guida Utente",
		"VIP"
	],
	sign: {
		title: "Accesso effettuato per {0} giorno",
		SignIn: "Accedi"
	},
	hotMusicAlbum: "Album di Musica Calda",
	hotMusic: "Classifiche delle Canzoni Calde",
	popular: "Nuova Riproduzione",
	rankings: "Film Popolari",
	top: "TOP{0}",
	OnchainServices: "Servizi Onchain",
	Real: {
		title: "In tempo reale",
		list: [
			"Utenti totali online",
			"Volume medio di ottimizzazione per utente",
			"Mappa di calore delle esigenze di ottimizzazione",
			"Quantità di ottimizzazione della promozione della piattaforma"
		]
	},
	work: {
		title: "Ricompensa per l'invio dell'ordine",
		SignIn: "Ottieni"
	},
	Profit: {
		Profit: "Profitto",
		tabs: ["Profitto", "Bonus", "Account"],
		TotalBalance: "Saldo Totale",
		TotalLuckyBonus: "Bonus Fortuna Totale",
		todayEarnings: "Ricavi di Oggi",
		availableBalance: "Saldo Disponibile",
		title: ["Ricavi di Oggi", "Ricavi Totali", "Account"],
		list: ["Ricavi degli Ordini", "Ricavi del Team", "Ricavi Totali"],
		order: {
			title: "Profitto degli Ordini",
			commission: "Commissione degli Ordini"
		},
		Analysis: {
			title: "Analisi del Profitto",
			tips: "Hai effettuato {0} transazioni",
			tabs: ["Profitto di Oggi", "Profitto Totale"],
			totalTitle: ["Profitto degli Ordini", "Profitto di Check-in", "Profitto del Team", "Profitto dei Bonus"]
		}
	},
	CustomerService: {
		title: "Centro Servizio Clienti",
		consultation: "Consultazione del servizio clienti",
		btn: "Contattaci",
		noticeTitle: "Notifica di Sistema"
	},
	addWallet: "Aggiungi portafoglio",
	taskProgress: "Progresso delle attività quotidiane",
	currentProgress: "Avanzamento attuale del compito",
	awardsBulletin: `{0} utente vince {1} {2} premio nel compito.`,
	vip: {
		title: "@:vip.title",
		more: "Visualizza altro"
	},
	stats: {
		title: "Fonti dati - Dashboard e API",
		subTitle: "Statistiche degli artisti",
		list: ["Metriche", "Artisti con social attivi", "Aggiornati quotidianamente"]
	}
};
